import { render, staticRenderFns } from "./fontsSettingsOther.vue?vue&type=template&id=2807fe2f&scoped=true&"
import script from "./fontsSettingsOther.vue?vue&type=script&lang=js&"
export * from "./fontsSettingsOther.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2807fe2f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpandTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VExpandTransition})
